/** CoStar.Api.AptsReviews.ViewModels.Activity.ActivityType */
export var ActivityType;
(function (ActivityType) {
    ActivityType[ActivityType["Unknown"] = 0] = "Unknown";
    ActivityType[ActivityType["WriteReview"] = 1] = "WriteReview";
    ActivityType[ActivityType["ShareReview"] = 2] = "ShareReview";
    ActivityType[ActivityType["ReviewHelpful"] = 3] = "ReviewHelpful";
})(ActivityType || (ActivityType = {}));
